module.exports = __webpack_public_path__ + "img/back_pocket_width_welt.b65cffc5.png";